import { useApiBase } from './useApiBase'

export interface McpToken {
  jti: string
  scope: string
  createdAt: number
  expiresAt: number
  revoked: boolean
}

export interface McpGrantRequest {
  redirect_uri: string
  code_challenge: string
  code_challenge_method: string
  scope?: string
  state?: string | null
}

export interface McpGrantResponse {
  code: string
  state: string | null
  redirectUri: string
  redirectTo: string
}

/**
 * user MCP サーバ（#548 / user-mcp-stack）を叩く API。
 *
 * base URL は通常の `apiBase` とは別で `runtimeConfig.public.userMcpBaseUrl` を使う。認証は
 * 既存 Cognito アクセストークン（`useApiBase` の `authenticatedFetch` をそのまま流用＝トークン
 * 更新 / 401 リトライも共有）。これらのエンドポイントは **生 JSON** を返す（gennai の ApiResponse
 * ラップではない）ので body 展開は不要。
 */
export function useUserMcpApi() {
  const { authenticatedFetch } = useApiBase()
  const config = useRuntimeConfig()
  const base = config.public.userMcpBaseUrl as string

  const listTokens = () =>
    authenticatedFetch<{ tokens: McpToken[] }>(`${base}/tokens`)

  const revokeToken = (jti: string) =>
    authenticatedFetch<{ revoked: boolean }>(
      `${base}/tokens/${encodeURIComponent(jti)}/revoke`,
      { method: 'POST' },
    )

  const grant = (req: McpGrantRequest) =>
    authenticatedFetch<McpGrantResponse>(
      `${base}/authorize/grant`,
      { method: 'POST', body: req as unknown as Record<string, unknown> },
    )

  return { base, listTokens, revokeToken, grant }
}
